import { common as enCommon } from './en/common';
import { common as esCommon } from './es/common';

const messages = {
  en: {
    common: enCommon,
  },
  es: {
    common: esCommon,
  },
};

export default messages; 